import { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { Header } from '@components';
import {
  isCondoWeeksFromPath,
  isCondoWorldFromPath,
  isLuxuryHomesFromPath,
  isThreeDSFromPath,
  isVacationRentalsFromPath,
  Responsive,
  RootState,
} from '@share/utils';
import { isCondoWeeklySpeccialMarketingFromPath, isErrorFromPath, isPublicCertificatePaymentFromPath, isWidgetFromPath } from '@share/utils';

export function ApplicationHeader() {
  const loginStore = useSelector((state: RootState) => state.loginStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);

  const { account } = loginStore;
  const { items } = menuStore;

  const history = useHistory();
  const { pathname } = useLocation();

  const isThreeDS = useMemo(() => isThreeDSFromPath(history), [pathname]);
  const isWidgetPage = useMemo(() => isWidgetFromPath(history), [pathname]);
  const isErrorPage = useMemo(() => isErrorFromPath(history), [pathname]);
  const isVacationRentals = useMemo(() => isVacationRentalsFromPath(history), [pathname]);
  const isCondoWorldMap = useMemo(() => isCondoWorldFromPath(history), [pathname]);
  const isCondoWeeks = useMemo(() => isCondoWeeksFromPath(history), [pathname]);
  const isLuxuryHomes = useMemo(() => isLuxuryHomesFromPath(history), [pathname]);
  const isCondoWeeklySpecialMarketing = useMemo(() => isCondoWeeklySpeccialMarketingFromPath(history), [pathname]);
  const isPublicCertificatePayment = useMemo(
    () => isPublicCertificatePaymentFromPath(history),
    [pathname],
  );

  // Check if Modern template should be used (both SiteId AND OrgId must match)
  const siteId = items?.siteId;
  const organizationId = items?.organizationId;
  const modernHomeTemplateOrgidList = account?.modernHomeTemplateOrgidList;
  const modernHomeTemplateSiteidList = account?.modernHomeTemplateSiteidList;

  const isInModernOrgId = modernHomeTemplateOrgidList?.includes(organizationId?.toString() as string);
  const isInModernSiteId = modernHomeTemplateSiteidList?.includes(siteId?.toString() as string);

  const useModernTemplate = account?.isRSITemplate && (
    (isInModernOrgId && isInModernSiteId) || 
    (account?.isModernTemplate)
  );

  if (isWidgetPage || isCondoWorldMap || isThreeDS || isCondoWeeks || isLuxuryHomes || isCondoWeeklySpecialMarketing || isPublicCertificatePayment || useModernTemplate) {
    return null;
  }

  return (
    <Responsive>
      <Header isError={isErrorPage} isVacationRentals={isVacationRentals} />
    </Responsive>
  );
}
